import { Component, OnInit, ViewChild } from '@angular/core';
import { RecPlanNameSearchGridComponent } from '../../components/rec-plan-name-search-grid/rec-plan-name-search-grid.component';
import { NavMenuService } from '../../../shared/services/nav-menu-service';

@Component({
  selector: 'app-rec-plan-name-result-pg',
  templateUrl: './rec-plan-name-result-pg.component.html',
  styleUrls: ['./rec-plan-name-result-pg.component.css']
})
export class RecPlanNameResultPgComponent implements OnInit {

  @ViewChild(RecPlanNameSearchGridComponent, { static: true }) recPlanNameResults;

  constructor(public nav: NavMenuService) {


  }



  ngOnInit() {

    //// hide the navigation menu.
    this.nav.hide();

  }

}
